/**
 * Admin session check for route guards. Hits GET /api/admin/me, which returns
 * 200 { admin: true } when the admin_session httpOnly cookie is valid (set by
 * POST /api/auth/login for role='admin' tenant users) and 401 otherwise.
 */
export async function checkAdminSession(): Promise<boolean> {
  try {
    const res = await fetch("/api/admin/me", { headers: { Accept: "application/json" } });
    return res.ok;
  } catch {
    return false;
  }
}
